import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'flightPaths';
const BASE_PATH = `${API_ROOT}/flightPaths`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (flightPathId) => `${BASE_PATH}/${flightPathId}`,
    GET: (flightPathId) => `${BASE_PATH}/${flightPathId}`,
    LIST: BASE_PATH,
    UPDATE: (flightPathId) => `${BASE_PATH}/${flightPathId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, flightPathId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(flightPathId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(flightPathId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(flightPathId)}?${params.toString()}`)).data;
}
function getKey(flightPathId, props) {
    return [CacheKey, 'get', flightPathId, props];
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.missionId)
        params.append('missionId', props.missionId);
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function update(csrfToken, flightPathId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(flightPathId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
